import React from 'react';

/**
 * "You have:" balance chips — credits · document spaces · Pending storage.
 * Shared by AutoSplitModal and the /pending page so the user sees the SAME object
 * wherever spending is decided. Deliberately quiet (Vara B2): small, muted, compact —
 * present and verifiable, never competing with the headline or the primary button.
 */
/* pantallas-alumno (G), parte 2 "Saldo" de Pendientes: "You have:" en 13 px #9A9A9A y los tres chips NEUTROS del
   Panel. Solo con `estilo="alumno"`; sin el, los chips de siempre (los de la ventana del documento grande). */
const CHIP_ALUMNO = 'inline-flex items-center h-[22px] px-2 rounded-full border border-[#2C2C2C] bg-[#1F1F1F] text-[12px] font-semibold text-[#D4D4D4] whitespace-nowrap';

export default function HaveChips({ t, credits, slots, pending, testid = 'have-chips', estilo }) {
  if (estilo === 'alumno') {
    return (
      <div className="flex flex-wrap items-center gap-1.5" data-testid={testid} data-estilo="alumno">
        <span className="text-[13px] text-[#9A9A9A] mr-0.5">{t('dashboard:auto_split.have_prefix')}</span>
        <span className={CHIP_ALUMNO}>{t('dashboard:auto_split.chip_credits', { count: credits })}</span>
        <span className={CHIP_ALUMNO}>{t('dashboard:auto_split.chip_slots', { count: slots })}</span>
        <span className={CHIP_ALUMNO}>{t('dashboard:auto_split.chip_pending', { n: pending })}</span>
      </div>
    );
  }
  const chip = 'text-[11px] text-[#a0a0a0] bg-[#1a1a1a] border border-[#262626] rounded-md px-2 py-0.5';
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid={testid}>
      <span className="text-[11px] font-medium text-[#8a8a8a]">{t('dashboard:auto_split.have_prefix')}</span>
      <span className={chip}>{t('dashboard:auto_split.chip_credits', { count: credits })}</span>
      <span className={chip}>{t('dashboard:auto_split.chip_slots', { count: slots })}</span>
      <span className={chip}>{t('dashboard:auto_split.chip_pending', { n: pending })}</span>
    </div>
  );
}
